import { z } from 'zod';

export const RemediationCodingToolIdSchema = z.enum([
  'amp',
  'claude-code',
  'codex-cli',
  'codex-desktop',
  'conductor',
  'cursor',
  'devin',
  'factory',
  'github-copilot',
  'lovable',
  'netlify-agent-runners',
  'opencode',
  'replit',
  'v0',
  'warp',
  'windsurf',
  'zed',
]);

export const RemediationCodingToolConfigSchema = z.object({
  toolId: RemediationCodingToolIdSchema,
  enabled: z.boolean(),
});

export const TenantRemediationCodingToolsSettingsSchema = z.object({
  enabledTools: z.array(RemediationCodingToolConfigSchema),
  defaultTool: RemediationCodingToolIdSchema.nullable(),
  promptTemplate: z.string(),
});

export const UpdateTenantRemediationCodingToolsSettingsSchema = z.object({
  enabledTools: z.array(RemediationCodingToolConfigSchema),
  defaultTool: RemediationCodingToolIdSchema.nullable().optional(),
  promptTemplate: z.string().min(1).optional(),
});
